import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { useTranslation } from 'react-i18next';

export default function ProtectedRoute() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const location = useLocation();
  const { i18n } = useTranslation();

  if (!isAuthenticated) {
    // Redirect to login page while saving the attempted location
    return (
      <Navigate
        to={`/${i18n.language}/auth/login`}
        state={{ from: location }}
        replace
      />
    );
  }

  return <Outlet />;
}